/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */

/*:: export type ObjectMap<Value> = {[key: string]: Value}; */

/**
 * Parses the URL query parameters and returns them as a key-value map.
 *
 * @return {Object} Returns a Key-Value map of the URL query parameters.
 */
export function getUrlParameters() /*: ObjectMap<string> */ {
  const qs =
    window.location.search
    || window.location.href.replace(/^[^?]*(\?[^#]*)?.*$/, '$1');

  return parseQueryString(qs);
}

/**
 * Parses a query string and returns it them as a key-value map.
 *
 * @param  {string} qs - The query string to parse
 * @return {Object} A key-value map of the query string parameters.
 */
export function parseQueryString(qs /*: string */) /*: ObjectMap<string> */ {
  const re = /[?&]+([^=&]+)=([^&]*)/gi;
  const map = {};
  let match;

  while ((match = re.exec(qs)) !== null) {
    // $FlowIssue Flow doesn't like "while" loops (facebook/flow#4983)
    map[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
  }

  return map;
}

export function stringifyQueryString(data /*: ObjectMap<string> */) /*: string */ {
  return `?${serializeFormData(data)}`;
}

export function serializeFormData(data /*: ObjectMap<string> */) /*: string */ {
  const params = [];

  for (const k in data) {
    if (Object.hasOwn(data, k)) {
      if (data[k] != null) {
        params.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
      }
    }
  }
  return params.join('&');
}

/**
 * Creates a delay promise.
 *
 * @param  {number} ms - The delay in milliseconds to wait before resolving.
 * @param  {*}      value - The value to resolve with.
 * @return {Promise} A promise that resolves with `value` after `ms` milliseconds.
 */
export function delay /*:: <T> */(ms /*: number */, value /*: T */) /*: Promise<T> */ {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms, value);
  });
}

export function shallowDiffers(a /*: Object */, b /*: Object */) /*: boolean */ {
  for (const i in a) {
    if (!(i in b)) {
      return true;
    }
  }
  for (const i in b) {
    if (a[i] !== b[i]) {
      return true;
    }
  }
  return false;
}

/*:: type DateFormat = 'short' | 'medium'; */

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function pad(number) {
  if (number < 10) {
    return `0${number}`;
  }
  return number.toString();
}
export function formatDate(date /*: Date */, format /*: DateFormat */ = 'medium') /*: string */ {
  switch (format) {
    case 'short':
      return `${pad(date.getUTCDate())}/${pad(
        date.getUTCMonth() + 1
      )}/${date.getUTCFullYear()}`;
    case 'medium':
    default:
      return `${
        MONTH_NAMES[date.getUTCMonth()]
      } ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
  }
}
